module.exports = __webpack_public_path__ + "img/icon-google-colors.0957991d.svg";